import React from 'react';
import { useTranslation } from 'react-i18next';

// components
import EmptyStateCard from 'shared/components/EmptyStateCard';
import { Arrow } from 'icons/untitledui';

// styles
import * as Styled from 'events/styles/EventsHomePage.style';

interface EmptyActivityProps {
  isViewingToday: boolean;
  onResetFilters?: () => void;
}

export default function EmptyActivity({
  isViewingToday,
  onResetFilters,
}: EmptyActivityProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  if (onResetFilters) {
    return (
      <EmptyStateCard
        title={t('emptyActivity.filteredTitle')}
        subtitle={t('emptyActivity.filteredSubtitle')}
        action={
          <Styled.EmptyStateResetButton
            type="button"
            $size="small"
            onClick={onResetFilters}
          >
            <Arrow.RefreshCcw01 />
            {t('emptyActivity.resetFilters')}
          </Styled.EmptyStateResetButton>
        }
      />
    );
  }

  return (
    <EmptyStateCard
      title={
        isViewingToday
          ? t('emptyActivity.title')
          : t('emptyActivity.pastDayTitle')
      }
      subtitle={
        isViewingToday
          ? t('emptyActivity.subtitle')
          : t('emptyActivity.pastDaySubtitle')
      }
    />
  );
}
